export default "__VITE_ASSET__C8DaMyTJ__"